import React from "react";

const NoBuilding = ({ message = "건물을 추가하고 관리를 시작해보세요" }) => {
    return (
        <div className="no-building-container">
          <img src="/noBuilding.png" alt="No Building" className="no-building-img" />
            <div className="no-building-label" dangerouslySetInnerHTML={{ __html: message }} ></div>
        </div>
    );
}

export default NoBuilding;